var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcCrossBlue = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f68b5;stroke:#fff;}.b{fill:none;}.c{fill:#fff;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-681.981 -507.981)"
}, /*#__PURE__*/React.createElement("g", {
  className: "a",
  transform: "translate(682.981 508.981)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "d",
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  className: "b",
  cx: 8,
  cy: 8,
  r: 8.5
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(683.912 509.912)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M0,0H14.138V14.138H0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M3.991,8.778V5.585H.8a.8.8,0,1,1,0-1.6H3.991V.8a.8.8,0,1,1,1.6,0V3.989H8.779a.8.8,0,1,1,0,1.6H5.586V8.778a.8.8,0,0,1-1.6,0Z",
  transform: "translate(7.069 0.299) rotate(45)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcCrossBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_cross_blue.388dd9d65490404f91318ab24182a280.svg";